import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

const root = ReactDOM.createRoot(document.getElementById("root"));
// const stripePromise = loadStripe("pk_test_51OklWZCkMbxWxxy81BHiUC8VrEZQt7QHXNFNS3BQ7veDmQZ8EaTvqEcHgSOeO0J9va6y8bv01UjXBet24NgbQ2s400GTGHFpqo");
// const options = {
//   clientSecret: "cus_PjIZc1nWUbFCsK_secret_sk_test_51OklWZCkMbxWxxy8Oisvavy7JTMjxNcp0jChl7uXUcjI0dgZmGvz8sVjEf4Zl3PeWnkBtGbskwgWR1oVVbegaMMM00IHb4EfFT",
// };
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
